import React, { forwardRef } from 'react';
import { SearcherDefinition } from 'shared/searchers';
import { useDragScroll } from '../useDragScroll';

interface HeroSearcherTabsProps {
  activeSearcherId?: string;
  className?: string;
  onSearcherSelect?: (id: string) => void;
  searchers: (SearcherDefinition & { show: boolean })[];
}

const HeroSearcherTabs = forwardRef<HTMLDivElement, HeroSearcherTabsProps>(
  function HeroSearcherTabs(
    { activeSearcherId, className = 'hero__searcher-tabs', onSearcherSelect, searchers },
    forwardedRef,
  ) {
    const drag = useDragScroll<HTMLDivElement>();

    function setRefs(node: HTMLDivElement | null) {
      drag.ref.current = node;
      if (typeof forwardedRef === 'function') {
        forwardedRef(node);
      } else if (forwardedRef) {
        forwardedRef.current = node;
      }
    }

    return (
      <div
        className={className}
        onMouseDown={drag.onMouseDown}
        onMouseLeave={drag.onMouseLeave}
        onMouseMove={drag.onMouseMove}
        onMouseUp={drag.onMouseUp}
        ref={setRefs}
      >
        {searchers.map((searcher) => {
          const iconStyle = {
            '--searcher-icon-url': `url("${searcher.iconUrl}")`,
          } as React.CSSProperties;

          if (searcher.urlOnly) {
            return (
              <a
                className='hero__searcher-tab hero__searcher-tab--link'
                href={searcher.url || '#'}
                key={searcher.id}
                onClick={(e) => {
                  if (drag.consumeDragged() || !searcher.url) e.preventDefault();
                }}
                rel='noopener noreferrer'
                target='_blank'
              >
                <span className='hero__searcher-tab-icon' style={iconStyle} />
                <span>{searcher.label}</span>
              </a>
            );
          }

          const isActive = searcher.id === activeSearcherId;
          return (
            <button
              className={['hero__searcher-tab', isActive && 'hero__searcher-tab--active']
                .filter(Boolean)
                .join(' ')}
              key={searcher.id}
              onClick={() => {
                if (drag.consumeDragged()) return;
                onSearcherSelect?.(searcher.id);
              }}
              type='button'
            >
              <span className='hero__searcher-tab-icon' style={iconStyle} />
              <span>{searcher.label}</span>
            </button>
          );
        })}
      </div>
    );
  },
);

export default HeroSearcherTabs;
